<script setup lang="ts">
import { cn } from "@client/lib/utils";
import { X } from "lucide-vue-next";
import { ToastClose, type ToastCloseProps } from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	ToastCloseProps & {
		class?: HTMLAttributes["class"];
	}
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ToastClose
		v-bind="delegatedProps"
		:class="
			cn(
				`tw:absolute tw:right-2 tw:top-2 tw:rounded-md tw:p-1 tw:text-slate-950/50 tw:opacity-0
				tw:transition-opacity tw:hover:text-slate-950 tw:focus:opacity-100 tw:focus:outline-none
				tw:focus:ring-2 tw:group-hover:opacity-100 tw:group-[.destructive]:text-red-300
				tw:group-[.destructive]:hover:text-red-50 tw:group-[.destructive]:focus:ring-red-400
				tw:group-[.destructive]:focus:ring-offset-red-600 tw:dark:text-slate-50/50
				tw:dark:hover:text-slate-50`,
				props.class,
			)
		">
		<X class="tw:h-4 tw:w-4" />
	</ToastClose>
</template>
